import React, { useContext, useEffect, useRef, useState ,useLayoutEffect} from "react";
import styles from "./style.module.css";

import SlButton from "../SlButton";
import Dropdown from "./Dropdown";
import { filterDataContext } from "./FilterDataProvider";
import { grantFilterContext } from "./GrantFilterProvider";
import { useRemembered, useMemoryKey, read, write } from "../utilities/pageMemory";
import CustomFilter from "./CustomFilter";
import { DeadlineControl, AmountControl } from "./RangeControls";

import LoadFilterMenu from "./SaveFilterButton/LoadFilterMenu";
import SaveFilter from "./SaveFilterButton"; 
import SaveAsMenu from "./SaveFilterButton/SaveAsMenu";


// Assigned-to dropdown deps
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { createPortal } from "react-dom";
import getClientDetails from "../../../../src/utils/getClientDetails";

export default function Filter({ onCurrentClientChange }) {
  const {
    extendMenu,
    setExtendMenu,
    extendedName,
    setExtendedName,
    allFilterCategoryArray = [],
    getCurrentFilterName,
  } = useContext(filterDataContext);

  // ---- Assigned to (client) dropdown state ----
  const dispatch = useDispatch();
  const clientsStore = useSelector((state) => state.clients);
  const location = useLocation();
  const buttonRef = useRef(null);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [currentClient, setCurrentClient] = useState(null);
  const [openModal, setOpenModal] = useState(false);
   const [clientNames, setClientNames] = useState([]);

  useEffect(() => {
    onCurrentClientChange?.(currentClient);
  }, [currentClient, onCurrentClientChange]);
  // Fetch clients once on mount
  useEffect(() => {
    getClientDetails(dispatch);
  }, [dispatch]);

  // Restore client from route state if present
  useEffect(() => {
    if (location.state?.currentClient) {
      setCurrentClient(location.state.currentClient);
    }
  }, [location.state]);

  // Build client list (skip deleted & non-userId keys)


  // ---- Saved filters controls ----
  const openSavedFilters = () => {
    setExtendedName("Open");
    setExtendMenu(true);
  };
  const closeSavedFilters = () => setExtendMenu(false);

  const isShowingSavedList = extendMenu && extendedName === "Open";
  const currentSavedFilter =
    typeof getCurrentFilterName === "function" ? getCurrentFilterName() : "default";
   


    useEffect(() => {
      getClientDetails(dispatch)
    }, []) 

  useEffect(() => {
      if (location.state?.currentClient) {
        setCurrentClient(location.state.currentClient)
      }
      if (location.state?.organization_name) {
        setClientNames(location.state.organization_name)
        openModalAtBegenning(location.state.organization_name)
      }
   
    }, [location.state])
    const buttonRect = buttonRef.current?.getBoundingClientRect();

  
    useEffect(() => {
      const lastClient = localStorage.getItem('LastClient');
      const clientIds = Object.keys(clientsStore);
  
      // If there is at least one client
      if (clientIds.length > 1) {
        // If the user has only one client
        if (clientIds.length === 1) {
          setCurrentClient({ ...clientsStore[clientIds[0]][Object.keys(clientsStore[clientIds[0]])[0]], client_id: Object.keys(clientsStore[clientIds[0]])[0] });
        }
        // If the user has more than one client
        else {
          // Check if the lastClient exists in the clientsStore
          const foundLastClient = clientIds.some(
            clientId => clientsStore[clientId][lastClient]
          );
  
          if (lastClient && foundLastClient) {
            setCurrentClient({ ...clientsStore[clientIds[1]][lastClient], client_id: lastClient });
          } else {
            // Fallback to setting the first available client if no last client is found
            setCurrentClient({ ...clientsStore[clientIds[1]][Object.keys(clientsStore[clientIds[1]])[0]], client_id: Object.keys(clientsStore[clientIds[1]])[0] });
          }
        }
      }
  
      
      
    }, [clientsStore]);

    function openModalAtBegenning(names){
    console.log('Entering Here')
    console.log(names)
     if(names.length===0){
      openModal(true)
     } 
  }
  useLayoutEffect(() => {
    let hasRun = localStorage.getItem('hasRunAfterLogin');
    if(hasRun == 'true'){
      if (Object.keys(clientsStore).length > 1) {
        const secondKey = Object.keys(clientsStore)[1];
        const clients = clientsStore[secondKey]
          ? Object.entries(clientsStore[secondKey])
              .filter(([_, client]) => !client.is_delete)
              .map(([client_id, client]) => ({
                ...client,
                client_id, // Add client_id to the client object
              }))
          : [];
    
        if (clients.length === 0) {
          setOpenModal(true);
          localStorage.setItem('hasRunAfterLogin', 'false');
        }else{
          
        }
      }
      
    }
  
  }, [clientsStore]);
  
    const clients = clientsStore
    ? Object.entries(clientsStore)
        .filter(([key]) => key !== "userId")
        .flatMap(([_, group]) =>
          Object.entries(group)
            .filter(([_, client]) => !client.is_delete)
            .map(([client_id, client]) => ({ ...client, client_id }))
        )
    : [];
  // Step 28: the pill summaries and the Clear All button read from the two
  // contexts. Nothing above this line changed.
  const { filterData, getActiveFilters, clearCurrentSelections, inited, setFilterData } =
    useContext(filterDataContext) || {};
  // Step 31: which pills are open is remembered per user ...
  const [openPills, setOpenPills] = useRemembered(useMemoryKey("pills"), {});
  const setPillOpen = (name, next) =>
    setOpenPills((previous) => ({ ...(previous || {}), [name]: next }));
  // ... and so are the ticked boxes. The provider loads the saved filters
  // from the server first; once that is done, the ticks left on this
  // browser take over, but only if nothing has been ticked yet, so a
  // fresh tick is never wiped. Every change is written back.
  const ticksKey = useMemoryKey("ticks");
  const ticksRestored = useRef(false);
  useEffect(() => {
    if (!inited || ticksRestored.current || typeof setFilterData !== "function") return;
    ticksRestored.current = true;
    const saved = read(ticksKey);
    if (!saved || !saved.buffer || typeof saved.buffer !== "object") return;
    const currentBuffer = filterData && filterData.filters ? filterData.filters.buffer : null;
    const hasTicks = currentBuffer && Object.keys(currentBuffer).length > 0;
    if (hasTicks) return;
    setFilterData({
      ...filterData,
      current: saved.current || (filterData && filterData.current) || "default",
      filters: { ...((filterData && filterData.filters) || {}), buffer: saved.buffer },
    });
  }, [inited, ticksKey, filterData, setFilterData]);
  useEffect(() => {
    if (!inited || !ticksRestored.current || !filterData || !filterData.filters) return;
    write(ticksKey, { current: filterData.current, buffer: filterData.filters.buffer || {} });
  }, [inited, ticksKey, filterData]);
  const {
    deadlineAfter, setDeadlineAfter,
    amountMin, setAmountMin,
    amountMax, setAmountMax,
  } = useContext(grantFilterContext) || {};
  const activeByCategory = groupByCategory(
    typeof getActiveFilters === "function" ? getActiveFilters(filterData) : []
  );
  const clearAll = () => {
    if (typeof clearCurrentSelections === "function") clearCurrentSelections();
    if (typeof setDeadlineAfter === "function") setDeadlineAfter("");
    if (typeof setAmountMin === "function") setAmountMin("");
    if (typeof setAmountMax === "function") setAmountMax("");
  };
  return (
    <div className={styles.filter_layout_container}>
      {/* Row A: client pill (was "Assigned to ...") */}
      <div className={styles.topBox}>
        <button
          ref={buttonRef}
          type="button"
          onClick={() => setOpenDropdown((prev) => !prev)}
          className={styles.clientPill}
        >
          <span className={styles.clientEyebrow}>Client</span>
          <span className={styles.clientName}>
            {currentClient?.organization_name || "Choose Client"}
          </span>
        </button>

        {openDropdown &&
          buttonRect &&
          createPortal(
            <ul
              className={styles.clientList}
              style={{
                position: "absolute",
                top: buttonRect.top,
                left: buttonRect.left,
                width: buttonRect.width,
                zIndex: 1000,
              }}
              onClick={(e) => {
                // the top band is the CLIENT line showing through; a click
                // there closes the list, as clicking the box does
                if (e.target === e.currentTarget) setOpenDropdown(false);
              }}
            >
              {clients.length === 0 && (
                <li className={`${styles.clientRow} ${styles.clientRowEmpty}`}>
                  No Client yet
                </li>
              )}
              {clients.map((client) => (
                <li
                  key={client.client_id}
                  className={styles.clientRow}
                  onClick={() => {
                    setCurrentClient(client);
                    localStorage.setItem("LastClient", client.client_id);
                    setOpenDropdown(false);
                  }}
                >
                  {client.organization_name}
                </li>
              ))}
            </ul>,
            document.body
          )}
      </div>

      {/* Row B: Saved Filters trigger */}
      <div id="savedFiltersBox" className={styles.relative}>
        <SlButton
          className={styles.saved_filters_button}
          onClick={openSavedFilters}
          aria-label="Saved Filters"
        >
          <span className={styles.savedFiltersLabel}>Saved Filters</span>
          {currentSavedFilter && currentSavedFilter !== "default" && (
            <span className={styles.activeSavedFilter} title={currentSavedFilter}>
              {currentSavedFilter}
            </span>
          )}
        </SlButton>
      </div>

      {/* Row C: list OR saved list OR full-panel Save As */}
      <div className={styles.main_filter_container}>
        {extendMenu && extendedName === "Save As" ? (
          // ---- Full-panel Save As ----
          <div className={styles.savedListMode}>
            <div className={styles.savedListHeader}>
              <button className={styles.backButton} onClick={() => setExtendMenu(false)}>
                &lt;
              </button>
              <span className={styles.savedListTitle}>Save As</span>
            </div>
            {/* The SaveAs form replaces the 3 filter groups */}
            <div style={{ maxWidth: 520 }}>
              <SaveAsMenu />
            </div>
          </div>
        ) : extendMenu && extendedName === "Open" ? (
          // ---- Saved filters list ----
          <div className={styles.savedListMode}>
            <div className={styles.savedListHeader}>
              <button className={styles.backButton} onClick={() => setExtendMenu(false)}>
                &lt;
              </button>
              <span className={styles.savedListTitle}>Select Saved Filter</span>
            </div>
            <LoadFilterMenu onClose={() => setExtendMenu(false)} />
          </div>
        ) : (
          // ---- Normal filters mode ----
          <>
            {/* Save Filter (opens the full-panel Save As) and Clear All */}
            <div className={styles.actionRow}>
              <SaveFilter />
              <button
                type="button"
                className={styles.clearAllButton}
                onClick={clearAll}
              >
                Clear All
              </button>
            </div>

            {/* Step 34, owner's word: Business Type sits right under the Save
                Filter / Clear All row, above Amount. It is drawn here rather
                than in the loop below only so it comes first; in every other
                way it is an ordinary checkbox group. */}
            <div className={styles.filterCard}>
              <Dropdown
                name={BUSINESS_TYPE_CATEGORY}
                label={PILL_LABELS[BUSINESS_TYPE_CATEGORY] || BUSINESS_TYPE_CATEGORY}
                summary={summarize(activeByCategory[BUSINESS_TYPE_CATEGORY])}
                startOpen={false}
                open={openPills && openPills[BUSINESS_TYPE_CATEGORY] === true}
                onToggle={(next) => setPillOpen(BUSINESS_TYPE_CATEGORY, next)}
              >
                <CustomFilter category={BUSINESS_TYPE_CATEGORY} pkey="business-type" />
              </Dropdown>
            </div>

            {/* Pills in the order of the owner's picture: Amount, then the
                checkbox groups (Agency, Category, Geography), then Deadline.
                All start closed; the summary shows the choice. */}
            <div className={styles.filterCard}>
              <Dropdown
                name="Amount"
                label="Amount"
                summary={formatAmount(amountMin, amountMax)}
                startOpen={false}
                open={openPills && openPills["Amount"] === true}
                onToggle={(next) => setPillOpen("Amount", next)}
              >
                <AmountControl />
              </Dropdown>
            </div>

            {Array.isArray(allFilterCategoryArray) &&
              allFilterCategoryArray
                .filter((category) => category !== BUSINESS_TYPE_CATEGORY)
                .map((category, i) => (
                <div className={styles.filterCard} key={`${category}-${i}`}>
                  <Dropdown
                    name={category}
                    label={PILL_LABELS[category] || category}
                    summary={summarize(activeByCategory[category])}
                    open={openPills && openPills[category] === true}
                    onToggle={(next) => setPillOpen(category, next)}
                  >
                    <CustomFilter category={category} pkey={i} />
                  </Dropdown>
                </div>
                ))}

            <div className={styles.filterCard}>
              <Dropdown
                name="Deadline"
                label="Deadline"
                summary={formatDeadline(deadlineAfter)}
                startOpen={false}
                open={openPills && openPills["Deadline"] === true}
                onToggle={(next) => setPillOpen("Deadline", next)}
              >
                <DeadlineControl />
              </Dropdown>
            </div>
          </>
        )}
      </div>

    </div>
  );
}

// ---------------------------------------------------------------------------
// Step 28: pure helpers for the pill text. No state, no side effects.
// ---------------------------------------------------------------------------

// What each category key is called on its pill. The keys themselves do not
// change; an unknown key is printed as it is.
const PILL_LABELS = {
  "Agency Type": "Agency",
  "Business Type": "Entity Type",
  "Categories": "Category",
  "Geographic Focus": "Geography",
};

// Step 34: the one group drawn by hand, above Amount, instead of in the loop.
const BUSINESS_TYPE_CATEGORY = "Business Type";

// Longest the joined names may run before the rest becomes " +N".
const SUMMARY_LIMIT = 22;

// [{category, value}] -> { category: [value, ...] }
function groupByCategory(pairs) {
  const grouped = {};
  if (!Array.isArray(pairs)) return grouped;
  pairs.forEach((pair) => {
    if (!pair || pair.category == null || pair.value == null) return;
    (grouped[pair.category] = grouped[pair.category] || []).push(String(pair.value));
  });
  return grouped;
}

// Names joined with ", " while the text stays within 22 characters, then
// " +N" for the rest. At least one name is always shown, so a long single
// name is clipped by the pill rather than replaced by a bare "+N".
function summarize(names) {
  if (!Array.isArray(names) || names.length === 0) return "Any";
  let text = names[0];
  let shown = 1;
  while (shown < names.length) {
    const next = `${text}, ${names[shown]}`;
    if (next.length > SUMMARY_LIMIT) break;
    text = next;
    shown += 1;
  }
  const rest = names.length - shown;
  return rest > 0 ? `${text} +${rest}` : text;
}

// 1000 -> "$1k", 1500000 -> "$1.5m", 100000000 -> "$100m", 500 -> "$500".
function formatMoney(digits) {
  const n = Number(digits);
  if (!Number.isFinite(n)) return `$${digits}`;
  const short = (value) => {
    const rounded = Math.round(value * 10) / 10;
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
  };
  if (n >= 1000000) return `$${short(n / 1000000)}m`;
  if (n >= 1000) return `$${short(n / 1000)}k`;
  return `$${n}`;
}

// "$100k - $100m", "from $100k", "up to $1m", or "Any".
function formatAmount(min, max) {
  const hasMin = min !== "" && min != null;
  const hasMax = max !== "" && max != null;
  if (hasMin && hasMax) return `${formatMoney(min)} - ${formatMoney(max)}`;
  if (hasMin) return `from ${formatMoney(min)}`;
  if (hasMax) return `up to ${formatMoney(max)}`;
  return "Any";
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// "2026-09-01" -> "after Sep 1, 2026"; "" -> "Any". The date box gives
// YYYY-MM-DD, which is read as plain text so no time zone can move the day.
function formatDeadline(iso) {
  if (!iso) return "Any";
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso));
  if (!match) return `after ${iso}`;
  const month = MONTHS[Number(match[2]) - 1];
  if (!month) return `after ${iso}`;
  return `after ${month} ${Number(match[3])}, ${match[1]}`;
}
